/// <reference path="../types/react-markdown-renderer.d.ts" />
import type { ComponentType } from "react";
import MarkdownRendererImport from "react-markdown-renderer";

export type MarkdownRendererProps = {
  markdown: string;
  options?: Record<string, unknown>;
};

type MarkdownRendererComponent = ComponentType<MarkdownRendererProps>;

/**
 * CJS package with `exports.__esModule` + `exports.default`.
 * Under Parcel/ESM the default import may be the module namespace
 * `{ default: Component }` instead of the component itself.
 */
const MarkdownRenderer = (
  typeof MarkdownRendererImport === "function"
    ? MarkdownRendererImport
    : (MarkdownRendererImport as unknown as { default: MarkdownRendererComponent })
        .default
) as MarkdownRendererComponent;

export default MarkdownRenderer;
